import styled from 'styled-components'

const TableHeader = styled.div`
  margin: 32px 0px 8px 0px;
  padding: 4px 0px 4px 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export default TableHeader
